export default "<h4>Main Landing View</h4>\r\n<div>\r\n    <h3>A component</h3>\r\n</div>\r\n\r\n";